import React, { useContext, useEffect, useState } from "react";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import SupplierContext from "../../../../contexts/SupplierContext";
import UserContext from "../../../../contexts/UserContext";
import {useNavigate} from "react-router-dom";
import spsCommerceLogo from "../../../../assets/images/spscommerce/spscommerce-logo.png";
import { OwAccordion } from "../../../shared/OwAccordion/OwAccordion";
import OwButton from "../../../shared/OwButton/OwButton";
import ISpsCommerceGetAuthorizeUrlDTO from "../../../../models/DTO/ISpsCommerceGetAuthorizeUrlDTO";
import ISpsCommerceOnGetAuthorizeUrlDTO from "../../../../models/DTO/ISpsCommerceOnGetAuthorizeUrlDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ISpsCommerceDisconnectDTO from "../../../../models/DTO/ISpsCommerceDisconnectDTO";
import ISpsCommerceOnDisconnectDTO from "../../../../models/DTO/ISpsCommerceOnDisconnectDTO";
import { Socket } from "socket.io-client";

type Props = {
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const SpsCommerceConnect: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const navigate = useNavigate();

    const [hasSpsCommerce, setHasSpsCommerce] = useState(supplierModel.Supplier_Integration.has_sps);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        props.socket.on(EndpointsEnum.SpsCommerceOnGetAuthorizeUrl, onGetAuthorizationUrl);
        props.socket.on(EndpointsEnum.SpsCommerceOnDisconnect, onDisconnect);

        return () => {
            props.socket.removeListener(EndpointsEnum.SpsCommerceOnGetAuthorizeUrl, onGetAuthorizationUrl);
            props.socket.removeListener(EndpointsEnum.SpsCommerceOnDisconnect, onDisconnect);
        };
    }, []);

    const viewLogs = () => {
        return;
    };

    const getAuthorizationUrl = () => {
        const payload: ISpsCommerceGetAuthorizeUrlDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        props.socket.emit(EndpointsEnum.SpsCommerceGetAuthorizeUrl, payload);
    };

    const onGetAuthorizationUrl = (data: ISpsCommerceOnGetAuthorizeUrlDTO) => {
        // @ts-expect-error
        window.location = data.url;
    };

    const getConnectedStatus = () => {
        return (
            <div className={"ms-auto d-flex align-items-center justify-content-center"}>
                {hasSpsCommerce ? <OwButton fn={viewLogs} title={"view_logs"} className={"me-3 btn-primary"} /> : null}
                {hasSpsCommerce ? null : <OwButton title={"connect"} fn={getAuthorizationUrl} />}
            </div>
        );
    };

    const disconnect = () => {
        const payload: ISpsCommerceDisconnectDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        props.socket.emit(EndpointsEnum.SpsCommerceDisconnect, payload);
    };

    const onDisconnect = (data: ISpsCommerceOnDisconnectDTO) => {
        setHasSpsCommerce(false);
        setIsActive(false);
    };

    const getMainContent = () => {
        return (
            <div>
                <div>
                    <OwButton className={"btn-sm btn-danger"} title={"disconnect"} fn={disconnect} />
                </div>
            </div>
        );
    };

    return (
        <div className={"SpsCommerceConnect"}>
            <OwAccordion
                hideChevron={!hasSpsCommerce}
                leftImage={spsCommerceLogo}
                leftImageHeight={50}
                leftImageAlt={"SPS Commerce"}
                rightElem={getConnectedStatus()}>
                {getMainContent()}
            </OwAccordion>
        </div>
    );
};
